import styled from 'styled-components';
import { width, space } from 'styled-system';
import { Button } from 'components/core';
import { Typography } from 'src/typography';

export const ListContainer = styled.div`
  margin-top: 34px;
  width: 100%;
`;

export const ListItemContainer = styled.div`
  display: flex;
  justify-content: space-between;

  ${space}
`;

export const ListItemCellContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${width}
`;

export const ListItemSecondaryHeader = styled.label`
  font-weight: bold;
  font-size: 11px;
  color: var(--dcm-account-label-color);
  line-height: 150%;
  text-transform: uppercase;
`;

export const ListItemMainHeader = styled(Typography.Heading)`
  color: var(--dcm-color-text-primary);
  font-family: var(--dcm-font-secondary);
`;

export const DataContainer = styled.p`
  color: var(--dcm-color-text-primary);
  font-family: var(--dcm-font-secondary);
  font-size: 13px;
`;

export const TabHeaderTitle = styled(Typography.Heading)`
  margin-bottom: 35px;
  color: var(--dcm-color-text-primary);
`;

export const StyledButton = styled(Button)`
  margin-top: 45px;
  height: 51px;
  padding: 12px 23px;
  width: 100%;
  font-size: 15px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: initial;
    height: 40px;
    font-size: 13px;
    margin-top: 64px;
  }
`;
